import styled from "styled-components";

const UploadInstructionsBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-bottom: 24px;
`;

export default UploadInstructionsBlock;
